/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Extract_Complete_LogInputs */

const en_drastic_tech_extract_complete_log = /** @type {(inputs: Drastic_Tech_Extract_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Extracting closed caption process complete-----`)
};

const fr_drastic_tech_extract_complete_log = /** @type {(inputs: Drastic_Tech_Extract_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Processus d'extraction termine-----`)
};

const de_drastic_tech_extract_complete_log = /** @type {(inputs: Drastic_Tech_Extract_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Extrahieren der Untertitel abgeschlossen-----`)
};

const it_drastic_tech_extract_complete_log = /** @type {(inputs: Drastic_Tech_Extract_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Processo di estrazione dei sottotitoli completato-----`)
};

const ru_drastic_tech_extract_complete_log = /** @type {(inputs: Drastic_Tech_Extract_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Процесс извлечения субтитров завершен-----`)
};

const es_drastic_tech_extract_complete_log = /** @type {(inputs: Drastic_Tech_Extract_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Proceso de extracción de subtítulos completado-----`)
};

const zh_cn2_drastic_tech_extract_complete_log = /** @type {(inputs: Drastic_Tech_Extract_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----字幕提取过程完成-----`)
};

const ja_drastic_tech_extract_complete_log = /** @type {(inputs: Drastic_Tech_Extract_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----クローズドキャプションの抽出プロセスが完了しました-----`)
};

const hi_drastic_tech_extract_complete_log = /** @type {(inputs: Drastic_Tech_Extract_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन निकालने की प्रक्रिया पूरी हुई`)
};

const pt_pt2_drastic_tech_extract_complete_log = /** @type {(inputs: Drastic_Tech_Extract_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Processo de extração de legendas concluído-----`)
};

/**
* | output |
* | --- |
* | "-----Extracting closed caption process complete-----" |
*
* @param {Drastic_Tech_Extract_Complete_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_extract_complete_log = /** @type {((inputs?: Drastic_Tech_Extract_Complete_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Extract_Complete_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_extract_complete_log(inputs)
	if (locale === "de") return de_drastic_tech_extract_complete_log(inputs)
	if (locale === "it") return it_drastic_tech_extract_complete_log(inputs)
	if (locale === "ru") return ru_drastic_tech_extract_complete_log(inputs)
	if (locale === "es") return es_drastic_tech_extract_complete_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_extract_complete_log(inputs)
	if (locale === "ja") return ja_drastic_tech_extract_complete_log(inputs)
	if (locale === "hi") return hi_drastic_tech_extract_complete_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_extract_complete_log(inputs)
	return en_drastic_tech_extract_complete_log(inputs)
});